module.exports = __webpack_public_path__ + "static/img/xgt10005602.c1431bba.jpg";